/* globals Vue, VueResource, google, InfoBox */
/* exports vm */
/* esnext */

const throttle = (func, limit) => {
    let lastFunc
    let lastRan
    return function() {
        const context = this
        const args = arguments
        if (!lastRan) {
            func.apply(context, args)
            lastRan = Date.now()
        } else {
            clearTimeout(lastFunc)
            lastFunc = setTimeout(function() {
            if ((Date.now() - lastRan) >= limit) {
                func.apply(context, args)
                lastRan = Date.now()
            }
            }, limit - (Date.now() - lastRan))
        }
    }
};

function distanceBetweenCoordinates(lat1, lng1, lat2, lng2) {
    var p = 0.017453292519943295; // Math.PI / 180
    var c = Math.cos;
    var a = 0.5 - c((lat2 - lat1) * p)/2 +
            c(lat1 * p) * c(lat2 * p) *
            (1 - c((lng2 - lng1) * p))/2;
    return Math.round(12742 * Math.asin(Math.sqrt(a)) * 1000); // 2 * R; R = 6371 km; 1000 = convert km to m
}

(function(){

    'use strict';

    var bus = window.vueBus;

    Vue.use(VueResource);

    var vm = new Vue({

        el: '#event-map-app',

        data: {
            config: {},
            translations: {},
            locations: [],

            map: null,
            mapMarkers: {},
            mapInfobox: null,
            highestMapZIndex: 0,

            openLocation: null,

            maxMarkerDistanceFromCenter: 6000 // m
        },

        beforeMount () {
            // Load config from global object

            this.config = window.$App;
            this.translations = window.$App.texts;

            this.locations = window.$App.maps.locations;

            // Click map (outside marker): Close infobox

            bus.$on('/map/click', location => {
                this.mapInfobox.close();
                this.openLocation = null;
            });

            // Click map marker: open infobox

            bus.$on('/map/location/click', location => {
                this.openLocation = location;
            });

        },

        mounted() {
            this.setupMap();
        },

        computed: {

            __ () {
                return this.translations;
            },

            mainLocation () {
                return this.locations.find(location => !!location.central);
            },

            numLocations () {
                return this.locations.length;
            },

        },

        methods: {

            showLocationOnMap(locationID) {
                if (this.mapLoaded && this.map && locationID) {
                    var marker = this.mapMarkers[locationID];
                    this.openMapInfobox(marker);
                }
            },

            openMapInfobox (marker, offset) {
                new google.maps.event.trigger(marker, 'click');
                this.map.panTo(marker.getPosition());
                if (offset) {
                    this.map.panBy(-offset / 2, 0);
                }
            },

            locationInfoBoxContent (location) {
                if (!location) {
                    return '';
                }

                var content = location.title + '<br />';

                content += '<div class="address">';
                if (location.district) {
                    content += location.district + '., ';
                }
                content += location.address;
                content += '</div>';

                content += '<ul class="event-links">';
                location.links.forEach(function(link) {
                    if (!link[0]) return;
                    var attr = link[2] ? ' target="_blank" rel="nofollow noopener noreferrer" ' : ''
                    content += '<li><a href="' + link[0] + '" ' + attr + '>' + link[1] + '</a></li>';
                });
                content += '</ul>';

                content += '<div class="event-icons">';
                location.flags.forEach(function(flag) {
                    // if flag contains 'headquarters', abort
                    if (flag.indexOf('headquarters') > -1) return
                    content += '<span class="event-icon event-icon--' + flag + '"></span>';
                });
                content += '</div>';

                return content;
            },

            getSavedMapPosition () {
                if (localStorage.map_position != null) {
                    var mapPos = JSON.parse(localStorage.map_position);
                    return {
                        lat: parseFloat(mapPos.lat),
                        lng: parseFloat(mapPos.lng),
                        zoom: parseInt(mapPos.zoom)
                    };
                }
                return false;
            },

            saveMapPosition () {
                if (!this.map) return;

                var center = this.map.getCenter();
                var data = {
                    lat: center.lat(),
                    lng: center.lng(),
                    zoom: this.map.getZoom()
                };
                localStorage.map_position = JSON.stringify(data);
            },

            distanceFromCenter (lat, lng) {
                return distanceBetweenCoordinates(lat, lng, this.config.maps.view.lat, this.config.maps.view.lng);
            },

            isCloseToMapCenter (lat, lng) {
                return this.distanceFromCenter(lat, lng) < this.maxMarkerDistanceFromCenter;
            },

            setMapBoundsAroundMarkers (markers) {
                if (!this.map || !markers.length) {
                    return;
                }

                var bounds = new google.maps.LatLngBounds();

                markers.forEach((marker) => {
                    var location = marker.customData.location;
                    if (this.isCloseToMapCenter(location.lat, location.lng)) {
                        bounds.extend(marker.position);
                    }
                });

                if(!bounds.isEmpty()) {
                    // Don't zoom in too far if markers are too close together
                    var distance = bounds.getNorthEast().lat() - bounds.getSouthWest().lat();
                    if (distance && distance <= 0.01) {
                        var extendPoint1 = new google.maps.LatLng(bounds.getNorthEast().lat() + 0.005, bounds.getNorthEast().lng() + 0.005);
                        var extendPoint2 = new google.maps.LatLng(bounds.getNorthEast().lat() - 0.005, bounds.getNorthEast().lng() - 0.005);
                        bounds.extend(extendPoint1);
                        bounds.extend(extendPoint2);
                    }
                    // Don't zoom in too far on only one marker
                    if (bounds.getNorthEast().equals(bounds.getSouthWest())) {
                        var extendPoint1 = new google.maps.LatLng(bounds.getNorthEast().lat() + 0.005, bounds.getNorthEast().lng() + 0.005);
                        var extendPoint2 = new google.maps.LatLng(bounds.getNorthEast().lat() - 0.005, bounds.getNorthEast().lng() - 0.005);
                        bounds.extend(extendPoint1);
                        bounds.extend(extendPoint2);
                    }

                    this.map.fitBounds(bounds);
                    this.map.setCenter(bounds.getCenter());
                    this.map.panToBounds(bounds);
                }

                return bounds.getCenter();
            },

            setupMap () {

                if (this.mapLoaded) {
                    return;
                }

                var that = this;

                this.mapLoaded = true;
                this.highestMapZIndex = this.numLocations;

                this.iconSize = window.innerWidth > 650 ? 24 : 14

                var lat = this.config.maps.view.lat,
                    lng = this.config.maps.view.lng,
                    initialZoom = this.config.maps.view.zoom || 14,
                    minZoom = 11;

                // Get map view config

                // Remember position from last session
                var prevPos = this.getSavedMapPosition();
                if (prevPos) {
                    initialZoom = prevPos.zoom;
                    lat = prevPos.lat;
                    lng = prevPos.lng;
                }

                var center = new google.maps.LatLng(
                    parseFloat(lat),
                    parseFloat(lng)
                );

                // Map options

                var mapOptions = {
                    zoom: initialZoom,
                    minZoom: minZoom,
                    center: center,
                    mapTypeId: 'roadmap',
                    backgroundColor: 'transparent',
                    scrollwheel: false,
                    disableDefaultUI: true,
                    zoomControl: true,
                    zoomControlOptions: {
                        position: google.maps.ControlPosition.RIGHT_CENTER
                    },
                    controlSize: 32,
                    styles: this.config.maps.style,
                    gestureHandling: 'greedy'
                };

                // Marker icon style

                var circleIcon = {
                    path: google.maps.SymbolPath.CIRCLE,
                    fillColor: '#003c82',
                    fillOpacity: 1,
                    scale: 12,
                    strokeWeight: 0
                };

                // Create map

                var map = new google.maps.Map(this.$refs.map, mapOptions);
                this.map = map;

                // Add map markers

                for (var i = 0; i < this.locations.length; i++) {
                    var location = this.locations[i];
                    var locationID = location.id;
                    var locationNumberChars = (location.number || '').toString().length,
                        markerHtml = '',
                        markerImageUri = null;

                    var position = new google.maps.LatLng(
                        parseFloat(location.lat),
                        parseFloat(location.lng)
                    );

                    // Clone marker SVG template and match to location info

                    try {
                        var markerNode = this.$refs.mapMarkerTemplate.querySelector('svg').cloneNode(true),
                        iconName = 'default',
                        icons = Array.from(markerNode.querySelectorAll('#map-marker #locations > [id]')),
                        nr = markerNode.querySelector('#number');

                        if (location.central || location.marker) {
                            iconName = location.marker || 'headquarters';
                            var customIcon = icons.find((icon) => icon.id === iconName);
                            if (customIcon?.matches('[data-without-number]')) {
                                nr.remove();
                            }
                        } else {
                            nr.innerHTML = location.number;
                            var fontSize = nr.getAttribute('font-size-length-' + locationNumberChars);
                            if (fontSize) {
                                nr.setAttribute('font-size', fontSize);
                            }
                            if (locationNumberChars > 1) {
                                nr.setAttribute('x', nr.getAttribute('x') - 1);
                                nr.setAttribute('y', nr.getAttribute('y') - 1);
                            }
                        }

                        icons.filter((icon) => icon.id !== iconName).forEach((icon) => icon.remove());

                        if (nr) {
                            nr.innerHTML = location.number;
                            if (location.active === false && nr.dataset.fillInactive) {
                                nr.setAttribute('fill', nr.dataset.fillInactive);
                            }
                        }

                        markerImageUri = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent('<?xml version="1.0"?>' + markerNode.outerHTML);
                    }
                    catch (e) {
                        console.error(e);
                    }

                    var zIndex = this.highestMapZIndex - location.number;
                    // Ensure central location is always on top
                    if (location.central) {
                        zIndex += 1;
                    }

                    var marker = new google.maps.Marker({
                        map: map,
                        position: position,
                        icon: markerImageUri ? { url: markerImageUri, scaledSize: new google.maps.Size(35, 35), optimized: false } : circleIcon,
                        zIndex: zIndex
                    });

                    marker.customData = {
                        location: location
                    };

                    marker.set('initialZIndex', zIndex);

                    this.mapMarkers[locationID] = marker;

                    google.maps.event.addListener(marker, 'click', (function(marker, locationID) {
                        return function() {
                            var location = that.locations.find(l => l.id === locationID);

                            infobox.setContent(that.locationInfoBoxContent(location));
                            infobox.open(map, marker);

                            if (true) {
                                // Force re-draw to fix a Google Maps bug
                                // that won't move InfoBox unless user interacts with map
                                var cnt = map.getCenter();
                                cnt.e+=0.000001;
                                map.panTo(cnt);
                                cnt.e-=0.000001;
                                map.panTo(cnt);
                            }

                            bus.$emit('/map/location/click', location);

                        };
                    })(marker, locationID));

                    var moveMarkerToFront = function() {
                        that.highestMapZIndex += 1;
                        this.setOptions({zIndex: that.highestMapZIndex});
                    };

                    google.maps.event.addListener(marker, 'click', moveMarkerToFront);
                    google.maps.event.addListener(marker, 'mouseover', moveMarkerToFront);
                }

                this.setMapBoundsAroundMarkers(Object.values(this.mapMarkers));

                // Info box for location details

                var infobox = new InfoBox({
                    alignBottom: true,
                    pixelOffset: new google.maps.Size(-110, -50), // sync with .event-map__infobox width in sass
                    infoBoxClearance: new google.maps.Size(40, 40),
                    maxWidth: 220, // sync with .event-map__infobox width in sass
                    zIndex: null,
                    boxClass: 'event-map__infobox',
                    closeBoxURL: '', // no close button
                });

                this.mapInfobox = infobox;

                // Register click event on map

                google.maps.event.addListener(map, 'click', function() {
                    bus.$emit('/map/click');
                });

                // Re-center on resize

                google.maps.event.addDomListener(window, 'resize', function() {
                    var center = map.getCenter();
                    google.maps.event.trigger(map, 'resize');
                    map.setCenter(center);
                });

                // Save position and zoom on move and zoom

                var saveMapPositionThrottled = throttle(
                    this.saveMapPosition.bind(this),
                    300
                );

                google.maps.event.addListener(map, 'center_changed', saveMapPositionThrottled);
                google.maps.event.addListener(map, 'zoom_changed', saveMapPositionThrottled);
            },

            centerMapOnUserLocation () {

                if (this.userLocation) {
                    return;
                }

                if (this.map) {

                    // Try HTML5 geolocation

                    if (window.location.protocol === 'https:' && navigator.geolocation) {

                        navigator.geolocation.getCurrentPosition(position => {

                                this.userLocation = {
                                    lat: position.coords.latitude,
                                    lng: position.coords.longitude
                                };

                                this.map.setCenter(this.userLocation);

                                // Location marker icon style

                                var circleIcon = {
                                    path: google.maps.SymbolPath.CIRCLE,
                                    scale: 5,

                                    fillColor: '#ea592f',
                                    fillOpacity: 1,

                                    strokeColor: '#ea592f',
                                    strokeOpacity: 0.4,
                                    strokeWeight: 18,
                                };

                                var marker = new google.maps.Marker({
                                    map: this.map,
                                    position: this.userLocation,
                                    icon: circleIcon,
                                    zIndex: 100
                                });
                            },

                            error => console.log(error)
                        );
                    }
                }
            }
        },

        watch: {
            mapLoaded () {
                this.centerMapOnUserLocation();
            }
        }
    });

})();
